import { Paper as _Paper, IconButton, styled, Typography } from '@mui/material'

export const Paper = styled(_Paper)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.grey[50],
}))

export const List = styled('ul')(({ theme }) => ({
  margin: theme.spacing(2),
  padding: theme.spacing(2),
  fontSize: '1rem',
  fontWeight: 'bold',
}))

export const ListItemText = styled(Typography)(({ theme }) => ({
  margin: theme.spacing(1, 0, 3),
})) as typeof Typography

export const EditButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.success.main,
  marginRight: theme.spacing(2),
}))
